import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import multiguard from "vue-router-multiguard";
import * as Cookie from "js-cookie";

const authGuard = function(to, from, next) {
  const user = JSON.parse(Cookie.get("user"));
  const loggedIn = !!user.token;
  const publicPages = ["/login", "/register", "/forgotpassword"];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next("/login");
  }

  return next();
};

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue")
    // import(/* webpackChunkName: "about" */ "../views/About.vue")
    // component: () =>
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue")
  },
  {
    path: "/marketplace",
    name: "marketplace",
    component: () => import("../views/MarketPlace.vue")
  },
  {
    path: "/marketdata",
    name: "marketdata",
    component: () => import("../views/MarketData.vue")
  },
  {
    path: "/marketinsights",
    name: "marketinsights",
    component: () => import("../views/MarketInsight.vue")
  },
  {
    path: "/marketplace/:id",
    name: "marketplaceDetails",
    component: () => import("../views/MarketPlaceDetails.vue")
  },
  {
    path: "/inventory",
    name: "inventory",
    component: () => import("../views/Inventory.vue")
  },
  {
    path: "/aggregator",
    name: "aggregator",
    component: () => import("../views/Aggregator.vue")
  },
  {
    path: "/aggregator/:type",
    name: "aggregatorDetails",
    component: () => import("../views/AggregatorDetails.vue")
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/Blog.vue")
  },
  {
    path: "/legal",
    name: "legal",
    component: () => import("../views/Legal.vue")
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login.vue")
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/auth/Signup.vue")
  },
  {
    path: "/forgotpassword",
    name: "Forgotpassword",
    component: () => import("../views/auth/Forgotpassword.vue")
  },
  {
    path: "/reset/password",
    name: "Resetpassword",
    component: () => import("../views/auth/Resetpassword.vue")
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../views/Cart.vue")
  },
  {
    path: "/dashboard",
    component: () => import("../views/user/layout/MainContainer.vue"),
    redirect: "/dashboard",
    beforeEnter: multiguard([authGuard]),
    children: [
      {
        path: "/dashboard",
        name: "Analytics",
        component: () => import("../views/user/Analytics.vue")
      },
      {
        path: "/dashboard/shipment",
        name: "Shipment",
        component: () => import("../views/user/Shipment.vue")
      },
      {
        path: "/dashboard/aggregator",
        name: "Aggregator",
        component: () => import("../views/user/Aggregator.vue")
      },
      {
        path: "/dashboard/inventory",
        name: "Inventory",
        component: () => import("../views/user/Inventory.vue")
      },
      {
        path: "/dashboard/wallet",
        name: "Wallet",
        component: () => import("../views/user/Wallet.vue")
      },
      {
        path: "/dashboard/profile",
        name: "Profile",
        component: () => import("../views/user/Profile.vue")
      }
    ]
  },

  // all other requests redirect to home
  { path: "*", redirect: "/dashboard" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // page scroll to top for all route navigations
    return { x: 0, y: 0 };
  }
});

export default router;
